import React from 'react';

type Props = {
  children: React.ReactNode;
};

const Toolbar = ({ children }: Props) => <>{children}</>;

export { Toolbar };
